// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8462) return "static/chunks/8462-ddb7fdd45d8fdc16.js";
	if (chunkId === 8407) return "static/chunks/8407-0efc384e990ff717.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"06dd6805e77e797b","530":"08b63ca4b640aea1","822":"0ea840547095c6da","1956":"1604385122b67d46","2121":"4e22807ed1b4f23b","2856":"e400c1c843ae4353","4316":"0eac8b3573f42d9a","6974":"4747d0de84eb661e"}[chunkId] + ".js";
};